module.exports = __webpack_public_path__ + "img/mbBanner6.d712c5fc.png";